import { useState, useCallback } from 'react'

// Column widths set by dragging (see AnchoColumnas.jsx): the shared helpers
// and the hook for a table that draws its own widths.

export const MIN = 48
export const leer = (k) => { try { return JSON.parse(localStorage.getItem(k) || '{}') } catch { return {} } }
export const guardar = (k, v) => { try { localStorage.setItem(k, JSON.stringify(v)) } catch { /* private mode */ } }

// Dragging: calls mover(dx) on every move, fin() on release.
export function arrastrar(e, mover, fin) {
  e.preventDefault()
  e.stopPropagation()
  const x0 = e.clientX
  const cursor = document.body.style.cursor
  document.body.style.cursor = 'col-resize'
  document.body.style.userSelect = 'none'
  const move = (ev) => mover(ev.clientX - x0)
  const up = () => {
    window.removeEventListener('mousemove', move)
    window.removeEventListener('mouseup', up)
    document.body.style.cursor = cursor
    document.body.style.userSelect = ''
    fin?.()
  }
  window.addEventListener('mousemove', move)
  window.addEventListener('mouseup', up)
}

// { [colId]: px } for a table, with defaults; arrastre(colId, e) on a grip.
export function useAnchos(clave, porDefecto) {
  const [anchos, setAnchos] = useState(() => ({ ...porDefecto, ...leer(clave) }))
  const arrastre = useCallback((id, e) => {
    const inicio = anchos[id] || porDefecto[id] || 120
    arrastrar(e, dx => setAnchos(a => ({ ...a, [id]: Math.max(MIN, Math.round(inicio + dx)) })),
      () => setAnchos(a => { guardar(clave, Object.fromEntries(Object.entries(a).filter(([k, v]) => v !== porDefecto[k]))); return a }))
  }, [anchos, clave, porDefecto])
  const reiniciar = useCallback((id) => setAnchos(a => {
    const n = { ...a, [id]: porDefecto[id] }
    guardar(clave, Object.fromEntries(Object.entries(n).filter(([k, v]) => v !== porDefecto[k])))
    return n
  }), [clave, porDefecto])
  return { anchos, arrastre, reiniciar }
}

